import { render, staticRenderFns } from "./media-form.vue?vue&type=template&id=4f8cc462&scoped=true"
import script from "./media-form.vue?vue&type=script&lang=js"
export * from "./media-form.vue?vue&type=script&lang=js"
import style0 from "./media-form.vue?vue&type=style&index=0&id=4f8cc462&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cc462",
  null
  
)

export default component.exports